import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form } from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class MultipleWorkType extends Component {
  handleWorkType(e, type) {
    e.preventDefault();

    this.props.assignAttribute('registeringTitle', type);
    if (type === 'work') {
      this.props.router.push('/copyright-reg/single-work-type/multiple');
    } else {
      this.props.router.push('/copyright-reg/multiple-work-type');
    }
  }

  render() {
    return (
      <div className="select-work work-type">
        <Heading text="What Kind of Titles Are You Registering?" />

        <div className="content">
          <Form>
            <Row>
              <Col md={6} sm={12} className="type-view">
                <div
                  className="type-image"
                  onClick={(e) => this.handleWorkType(e, 'work')}
                >
                  <span>Multiple titles that have not been released</span>
                </div>
              </Col>
              <Col md={6} sm={12} className="type-view">
                <div
                  className="type-image"
                  onClick={(e) => this.handleWorkType(e, 'collection')}
                >
                  <span>
                    Multiple titles that have been released together in a
                    collection (e.g. a music album)
                  </span>
                  <span className="sub-title">
                    If your titles were not released as a collection, please go
                    back and register each title separately.
                  </span>
                </div>
              </Col>
            </Row>
          </Form>
        </div>

        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.push('/copyright-reg/work-type')}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(null, mapDispatchToProps)(MultipleWorkType);



// WEBPACK FOOTER //
// src/components/Copyright/MultipleWork.jsx